<template>
  <div class="h-full px-8 py-0 w-full overflow-auto">
    <div
      class="flex w-full justify-between items-center sticky top-0 z-[2] bg-[#f4f4f5] pt-8"
    >
      <div class="text-4xl title-color">Aide & Support</div>
    </div>
    <div class="py-4"></div>
    <DataGetter
      @dataAvailable="
        data => {
          subscription = data?.metaData || {}
        }
      "
      contentId="subscription"
    />

    <Chat v-if="isPro" />
    <div class="h-full w-full flex flex-col items-center pt-12" v-else>
      <div class="!w-full max-w-[40rem]">
        <FormComponent
          class="w-full grid grid-cols-12 gap-x-4"
          :fields="fields"
          :onFormSubmited="
            data => {
              sendMessage(data)
            }
          "
          :loading="false"
          ref="form"
        >
          <template #submitButton>
            <button
              class="buttonComponent col-span-12"
              type="submit"
              ref="submit"
            >
              Envoyer
            </button>
          </template>
        </FormComponent>
      </div>
      <div class="py-4"></div>
      <div class="">
        <router-link
          to="/pro"
          class="text-primary underline"
          href="mailto:support@marketplace.ecoxurf.com"
        >
          Pour un chat en live avec nos support, passez à EkiDiscount Pro
        </router-link>
      </div>
    </div>
    <EventListener
      :events="['help_message_sent', 'help_message_not_sent']"
      @help_message_sent="onHelpMessageSent"
      @help_message_not_sent="onHelpMessageNotSent"
    />
  </div>
</template>

<script>
import Chat from '@/components/appData/Chat.vue'
import EventListener from '@/components/utils/EventListener.vue'
import FormComponent from '@/components/utils/FormComponent.vue'

import checkIcon from '@/assets/images/all/check.png'
import DataGetter from '@/components/utils/DataGetter.vue'

export default {
  name: 'homeComponent',
  components: {
    Chat,
    FormComponent,
    EventListener,
    DataGetter,
  },
  data() {
    return {
      subscription: {},
      userData: {},
      fields: [
        {
          type: 'text',
          propertyName: 'lastName',
          defaultValue: '',
          placeHolder: 'Entrez votre prénom',
          label: 'Prénom',
          required: true,
          class: 'col-span-12',
        },
        {
          type: 'text',
          propertyName: 'firstName',
          placeHolder: 'Entrez votre nom',
          label: 'Nom',
          defaultValue: '',
          required: true,
          class: 'col-span-12',
        },
        {
          placeHolder: 'Entrez votre Email',
          type: 'email',
          propertyName: 'email',
          label: 'Email',
          defaultValue: '',
          required: true,
          class: 'col-span-12',
        },
        {
          placeHolder: 'Donnez une breve description de votre',
          type: 'textarea',
          propertyName: 'subject',
          label: 'Sujet',
          defaultValue: '',
          required: true,
          class: 'col-span-12',
        },
      ],
    }
  },
  mounted() {},
  methods: {
    sendMessage(data) {
      this.$Events.dispatchEvent('start_loading', { title: 'Envoie en cours' })
      this.$Events.dispatchEvent('help_message_request_filled', {
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
        subject: data.subject,
      })
    },
    async onHelpMessageSent() {
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Message envoyé',
        body: 'Message envoyé. Nous vous répondrons dans le plus brèves délais',
      })
      await new Promise(r => setTimeout(r, 500))
      this.$Events.dispatchEvent('request:customPrompt', {
        title: '<div class="text-center">Message envoyé</div>',
        subTitle: `<div><img class="w-1/3 mx-auto " src="${checkIcon}"/></div><div class="py-2"></div><div class="text-center">Message envoyé. Nous vous répondrons dans le plus bèves délais</div>`,
      })
      this.$refs.form.setDefaultFields(true)
    },
    onHelpMessageNotSent() {
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        title: "Erreur d'envoie",
        body: "Désolé, nous n'avons pas pu envoyer le message, veuillez réessayer",
      })
    },
  },
  computed: {
    isPro() {
      return !!this.subscription.isActive
    },
  },
}
</script>
